export function resolveHsocCardBadges({
  tiers,
  serverBadgeNameByApiName,
  recommendedTierName
}) {
  const badges = {};
  tiers.forEach(({
    tierName,
    productApiName
  }) => {
    if (serverBadgeNameByApiName[productApiName] === 'CURRENT_PLAN') {
      badges[tierName] = {
        type: 'currentPlan'
      };
      return;
    }
    if (recommendedTierName === tierName) {
      badges[tierName] = {
        type: 'recommended'
      };
    }
  });
  return badges;
}